const drawerWidth = 200;
export const useStyles = (theme) => ({
  root: {
    marginLeft: drawerWidth,
    padding: 30,
    marginTop: 50,
    backgroundColor: "#f9f9fc",
    [theme.breakpoints.down("md")]: {
      marginLeft: "auto",
      marginRight: "auto",
      padding: 20,
    },
  },
  inputWithMargin: {
    width: "49%",
    marginRight: 15,
    [theme.breakpoints.between(960, 789)]: {
      marginRight: 15,
    },
    [theme.breakpoints.between(789, 539)]: {
      marginRight: 10,
    },
    [theme.breakpoints.down(539)]: {
      width: "100%",
    },
  },
  inputWithoutMargin: {
    width: "49%",
    [theme.breakpoints.down(539)]: {
      width: "100%",
    },
  },
  inputRoot: {
    height: 70,
  },
  labelRoot: {
    fontSize: 18,
    fontWeight: "bolder",
    backgroundColor: "#f9f9fb",
    paddingRight: 5,
  },
  notchedOutline: {},
  labelFocused: { color: "black !important" },
  focused: {
    "& $notchedOutline": {
      borderColor: "black !important",
    },
  },
  buttonStyle: {
    background: "#0a1f3a !important",
    outlineColor: "#0a1f3a !important",
    color: "#ffffff",
    fontSize: 18,
    borderRadius: 20,
    textTransform: "none",
    marginRight: 10,
    "&:hover": {
      backgroundColor: "#eee !important",
      borderColor: "#0a1f3a !important",
      color: "#181818",
    },
  },
  messageLoading: {
    fontSize: 25,
    fontWeight: "bold",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  tooltip: {
    "&:hover": { cursor: "pointer" },
  },
});
